import { getAuth } from 'util/auth';
import { useSelector } from 'react-redux';

const useAuth = () => {
  return useSelector(getAuth);
};

export default useAuth;
